import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import Radium from 'radium';
import queryString from 'query-string';

import * as styles from '../../styles';
import Dialog from '../../dialog/dialog';
import Content from '../../content-manager/content';
import {outerPaths, regions} from './paths';
import {request} from '../../containers/actions';
import {setSelectedItems} from '../tree/actions';
import Tree from '../tree';
import {Elevation, Card, CardPrimary, CardTitle, CardSubtitle, CardSupportingText, CardActions, CardAction} from 'rmwc';
import tinyMCEConfig from '../../utilities/tinymce_config';

const regionStyle = {
    fill: '#feaf78',
    stroke: 'black',
    strokeWidth: '.5px',
    cursor: 'pointer',
    ':hover': {
        fill: '#f8a25e',
    },
};

//@Radium
export default class ClientsMap extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {selectedClient: false}

    async componentDidMount() {
        const response = await this.context.store.dispatch(request({
            path: '/content/get/',
            body: {uri: '/regions/'},
        }));
        this.setState({
            content: response.content,
            contentId: response.id,
        });
    }

    async componentWillUpdate(nextProps) {
        if (nextProps.store.getIn(['regionsTree', 'selected']) !== this.props.store.getIn(['regionsTree', 'selected'])) {
            this.setState({selectedClient: false});
            if (nextProps.store.getIn(['regionsTree', 'selected']).size > 0)
                this.setState({
                    clients: (await this.context.store.dispatch(request({
                        path: '/client/?' + queryString.stringify({
                            region: nextProps.store.getIn(['regionsTree', 'selected']).keySeq().first(),
                            published: 'True',
                            o: 'order,title',
                        }),
                    }))).results,
                });
            else {
                const response = await this.context.store.dispatch(request({
                    path: '/content/get/',
                    body: {uri: '/regions/'},
                }));
                this.setState({
                    content: response.content,
                    contentId: response.id,
                });
            }
        }
    }

    render() {
        return <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: 'calc(100% - 2em)',
            }}>
            <div style={{flex: '1', marginLeft: '1em', width:'40%'}}>
                {this.props.store.getIn(['regionsTree', 'selected']).size > 0
                    ? <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                        <Dialog isOpen={this.state.selectedClient}>
                            <Content
                                key='description'
                                style={{
                                    height: undefined,
                                    minHeight: '5em',
                                    width: '40em',
                                }}
                                inline
                                readonly={!this.context.user.hasPerm('admin')}
                                content={((_.find(this.state.clients, {id: this.state.selectedClient}) || {}).description || '')}
                                tinymceConfig={{
                                    ...tinyMCEConfig,
                                    toolbar: [
                                        ...tinyMCEConfig.toolbar.slice(0, -1),
                                        tinyMCEConfig.toolbar.slice(-1)[0] + ' | map toggle_position toggle_size',
                                    ],
                                }}
                                onChange={content => this.setState({description: content})}
                            />
                            <div>
                                <i
                                    style={{float: 'right', cursor: 'pointer'}}
                                    className='fa-times fa-lg'
                                    onClick={() => this.setState({selectedClient: false})}>
                                </i>
                                {this.context.user.hasPerm('admin')
                                    ? <i
                                        style={{float: 'right', cursor: 'pointer'}}
                                        className='fa-check fa-lg'
                                        onClick={async () => {
                                            await window.wait();
                                            const response = await this.context.store.dispatch(request({
                                                path: `/client/${this.state.selectedClient}/`,
                                                body: {
                                                    description: this.state.description,
                                                },
                                                method: 'PATCH',
                                            }));
                                            const clientIndex = _.find(this.state.clients, {id: this.state.selectedClient});
                                            this.setState(update(
                                                this.state,
                                                {clients: {$splice: [[clientIndex, 1, response]]}},
                                            ));
                                            this.setState({selectedClient: false});
                                        }}>
                                    </i>
                                    : null
                                }
                            </div>
                        </Dialog>
                        <h3>
                            {this.props.store.getIn(['regionsTree', 'selected']).valueSeq().first()}
                        </h3>
                        <div style={{overflowY: 'auto', overflowX: 'hidden', flex: '1', padding: '.5em'}}>
                            {_.map(this.state.clients, client => <Card key={client.id} style={{marginTop: '.5em'}}>
                                <CardPrimary>
                                    {client.description
                                        ? <CardActions style={{float: 'left', marginTop: '-.5em'}}>
                                            <CardAction
                                                onClick={() => this.setState({selectedClient: client.id})}>
                                                {window.gettext('More Info')}
                                            </CardAction>
                                        </CardActions>
                                        : null
                                    }
                                    <CardTitle>
                                        {client.title}
                                    </CardTitle>
                                    <CardSubtitle>
                                        <span style={{fontWeight: '600'}}>{window.gettext('City')}:</span>
                                        &nbsp;
                                        {client.city.name}
                                    </CardSubtitle>
                                </CardPrimary>
                                <CardSupportingText>
                                    <span style={{fontWeight: '600'}}>{window.gettext('Phone')}:</span>
                                    &nbsp;
                                    {(client.phone || '').persian()}
                                    <br/>
                                    <span style={{fontWeight: '600'}}>{window.gettext('Address')}:</span>
                                    &nbsp;
                                    {(client.address || '').persian()}
                                    <br/>
                                    {client.brief_description}
                                </CardSupportingText>
                            </Card>)}
                        </div>
                    </div>
                    : <Elevation z='4' style={{height: '100%', display: 'flex', flexDirection: 'column', padding: '.5em'}}>
                        <Content
                            style={{flex: '1', width: '100%', overflowY: 'auto', overflowX: 'hidden'}}
                            inline
                            readonly={!this.context.user.hasPerm('admin')}
                            content={this.state.content}
                            tinymceConfig={{
                                ...tinyMCEConfig,
                                toolbar: [
                                    ...tinyMCEConfig.toolbar.slice(0, -1),
                                    tinyMCEConfig.toolbar.slice(-1)[0] + ' | map toggle_position toggle_size',
                                ],
                            }}
                            onChange={content => this.setState({content})}
                        />
                        {this.context.user.hasPerm('admin')
                            ? <div>
                                <button
                                    style={{...styles.defaultButton, float: 'left'}}
                                    onClick={async () => {
                                        await window.wait();
                                        const response = await this.context.store.dispatch(request({
                                            path: this.state.contentId ? `/content/${this.state.contentId}/` : '/content/',
                                            body: {
                                                content: this.state.content,
                                                uri: '/regions/',
                                            },
                                            method: this.state.contentId ? 'PATCH' : 'POST',
                                        }));
                                        this.setState({content: response.content, contentId: response.contentId});
                                    }}>
                                    {window.gettext('Save')}
                                </button>
                            </div>
                            : null
                        }
                    </Elevation>
                }
            </div>
            <div style={{position: 'relative', height: '100%', width:'60%'}}>
                <div
                    style={{position: 'absolute', top: '3vh', right: '9vh', width: 'calc(25vh + 3em)', fontSize: '.8em'}}>
                    <Tree
                        store={this.props.store.get('regionsTree')}
                        readonly
                        resource='region'
                        itemLabel='name'
                        multiSelection={false}
                        combobox
                        label={window.gettext('Region')}
                    />
                </div>
                <svg
                    style={{
                        fillRule: 'evenodd',
                        height: '100%',
                    }}
                    viewBox='30 160 560 542'>
                    {outerPaths}
                    {_.map(
                        regions,
                        (path, id) => <a
                            key={'anchor-' + id}
                            onClick={() => this.context.store.dispatch(setSelectedItems(
                                [id],
                                'region',
                                this.props.store.getIn(['regionsTree', 'elementId'])
                            ))}
                            xlinkTitle={this.context.store.getState().getIn(['trees', 'items', 'region:limit=100000', id, 'name'])}>
                            <path
                                key={'path-' + id}
                                style={{
                                    ...regionStyle,
                                    fill: this.props.store.getIn(['regionsTree', 'selected']).keySeq().first() === id
                                        ? '#d57c44'
                                        : regionStyle.fill,
                                }}
                                d={path}
                            />
                        </a>,
                    )}
                </svg>
            </div>
        </div>;
    }
}
